import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppService } from 'src/app/utils/services/app.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DataProvider } from 'src/providers/data/data';

@Component({
  selector: 'app-comp',
  templateUrl: './comp.component.html',
  styleUrls: ['./comp.component.scss'],
})
export class AccountListCompComponent implements OnInit, OnDestroy {
  public changePasswordForm: FormGroup;
  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: AppService,
    private router: Router,
    public data: DataProvider
  ) {}

  ngOnInit() {
    this.data.menuPageTitle = 'wf-account-list';

  }

  ngOnDestroy() {
    this.renderer.removeClass(
      document.querySelector('app-root'),
      'change-password-page'
    );
  }
  back() {
    this.router.navigate(['/wf-account-list']);
  }
}
